import axios from 'axios'

/**
 * A refresh attempt may fail because the network or service is temporarily
 * unavailable. Only an explicit 401 proves that the cookie-backed session is
 * no longer usable and authorizes clearing local authentication state.
 */
export function isConfirmedAuthFailure(error: unknown): boolean {
  return axios.isAxiosError(error) && error.response?.status === 401
}
